import { render, staticRenderFns } from "./InitializeComponent.vue?vue&type=template&id=916aeb62&"
import script from "./InitializeComponent.vue?vue&type=script&lang=js&"
export * from "./InitializeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports